import axios from "axios";
import type { PropsWithChildren } from "react";
import { useEffect } from "react";
import { throttle } from "@exonn/utils";
import type { Router } from "@remix-run/router";
import NiceModal from "@ebay/nice-modal-react";
import { ModalIDEnum } from "src/lib/nice-modal-react/nice-modal-react.ts";

const CHECK_APP_VERSION_THROTTLE_INTERVAL = 10_000;

export type Build = {
  build_number: string;
};

const getBuild = async (): Promise<Build> => {
  const res = await axios.get(`/build.json?v=${+new Date()}`);
  return res.data;
};

const getActualAppVersion = () => getBuild().then((res) => res.build_number);
const getClientAppVersion = () => import.meta.env.VITE_BUILD_NUMBER;

export const AppVersionChecker = (
  props: PropsWithChildren<{
    router: Router;
  }>,
) => {
  const { children, router } = props;

  useEffect(() => {
    const [checkAppVersion, cancelCheckAppVersion] = throttle(
      () =>
        getActualAppVersion().then((actualAppVersion) => {
          const clientAppVersion = getClientAppVersion();
          if (actualAppVersion !== clientAppVersion) {
            window.require_reload = true;
          }
        }),
      CHECK_APP_VERSION_THROTTLE_INTERVAL,
    );

    const unsubscribeRouter = router.subscribe(checkAppVersion);

    return () => {
      unsubscribeRouter();
      cancelCheckAppVersion();
    };
  }, [router]);

  useEffect(() => {
    return router.subscribe((state) => {
      if (state.navigation.location) {
        // don't reload during pending navigation
        return;
      }
      if (window.require_reload && !window.dont_ask_about_window_reload) {
        NiceModal.show(ModalIDEnum.PreloadError);

        // forcefully download new version of the application by reloading a browser during page navigation
        // window.location.href = state.location.pathname + state.location.search;
      }
    });
  }, [router]);

  return <>{children}</>;
};
